if (!customElements.get('iyrs-installments')) {
  customElements.define('iyrs-installments', class IyrsInstallments extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-iyrs-installment-price]');
      this.prices = JSON.parse(this.querySelector('[data-iyrs-installments-map]')?.textContent || '[]');
      this.onVariant = (event) => this.update(event.detail?.variant?.id);
      this.update(this.closest('product-info')?.querySelector('.m-product-form--main [name="id"]')?.value);
      document.addEventListener('variant:changed', this.onVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariant);
    }

    update(variantId) {
      const row = this.prices.find(({ id }) => Number(id) === Number(variantId)) || this.prices[0];
      if (row && this.output) this.output.textContent = row.payment;
    }
  });
}

if (!customElements.get('iyrs-bundle')) {
  customElements.define('iyrs-bundle', class IyrsBundle extends HTMLElement {
    connectedCallback() {
      this.currency = this.dataset.currency || 'USD';
      this.main = this.querySelector('[data-iyrs-bundle-main]');
      this.checks = Array.from(this.querySelectorAll('[data-iyrs-bundle-check]'));
      this.button = this.querySelector('[data-iyrs-bundle-add]');
      this.message = this.querySelector('[data-iyrs-bundle-message]');
      this.mainVariantId = Number(this.dataset.mainVariantId);
      this.mainAvailable = this.dataset.mainAvailable === 'true';
      this.onVariant = (event) => this.updateMain(event.detail?.variant);

      this.checks.forEach((check) => check.addEventListener('change', () => this.update()));
      this.querySelectorAll('[data-iyrs-bundle-variant]').forEach((select) => {
        select.addEventListener('change', () => this.updateAccessory(select));
      });
      this.button?.addEventListener('click', () => this.add());
      document.addEventListener('variant:changed', this.onVariant);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariant);
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.currency,
      }).format(Number(cents || 0) / 100);
    }

    updateMain(variant) {
      if (!variant || !this.main) return;
      this.mainVariantId = Number(variant.id);
      this.mainAvailable = Boolean(variant.available);
      this.main.dataset.price = variant.price;
      this.main.dataset.compare = variant.compare_at_price || variant.price;
      const title = this.querySelector('[data-iyrs-bundle-main-variant]');
      const price = this.querySelector('[data-iyrs-bundle-main-price]');
      if (title) title.textContent = variant.title;
      if (price) price.textContent = this.money(variant.price);
      this.update();
    }

    updateAccessory(select) {
      const item = select.closest('[data-iyrs-bundle-accessory]');
      const check = item?.querySelector('[data-iyrs-bundle-check]');
      const price = item?.querySelector('[data-iyrs-bundle-accessory-price]');
      const option = select.selectedOptions[0];
      if (!check || !option) return;
      check.dataset.variantId = option.value;
      check.dataset.price = option.dataset.price;
      check.dataset.compare = option.dataset.compare || option.dataset.price;
      check.dataset.available = option.dataset.available;
      if (price) price.textContent = option.dataset.priceFormatted || this.money(option.dataset.price);
      this.update();
    }

    selectedItems() {
      return [
        { id: this.mainVariantId, quantity: 1 },
        ...this.checks
          .filter((check) => check.checked && check.dataset.available === 'true')
          .map((check) => ({ id: Number(check.dataset.variantId), quantity: 1 })),
      ];
    }

    update() {
      let total = Number(this.main?.dataset.price || 0);
      let compare = Number(this.main?.dataset.compare || total);
      this.checks.forEach((check) => {
        if (!check.checked || check.dataset.available !== 'true') return;
        total += Number(check.dataset.price || 0);
        compare += Number(check.dataset.compare || check.dataset.price || 0);
      });
      const totalNode = this.querySelector('[data-iyrs-bundle-total]');
      const compareNode = this.querySelector('[data-iyrs-bundle-compare]');
      const countNode = this.querySelector('[data-iyrs-bundle-count]');
      if (totalNode) totalNode.textContent = this.money(total);
      if (compareNode) {
        compareNode.textContent = this.money(compare);
        compareNode.hidden = compare <= total;
      }
      if (countNode) countNode.textContent = this.selectedItems().length;
      if (this.button) this.button.disabled = !this.mainAvailable;
    }

    async add() {
      if (!this.button || !this.mainAvailable) return;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      if (this.message) this.message.textContent = '';

      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections },
        }));
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: this.selectedItems(),
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'Unable to add bundle');

        if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: payload });
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
        }
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: payload } }));
        if (this.message) this.message.textContent = 'Bundle added to cart.';
      } catch (error) {
        if (this.message) this.message.textContent = error.message || 'Unable to add the bundle. Please try again.';
      } finally {
        this.button.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}
